import React, { useContext } from 'react'

import { Container, UserContext } from '@doist/marketist'

import { Footer, Navbar, Seo } from 'components'
import { HtmlRenderer } from 'components/html-renderer'
import { GetServerSidePropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import htmlContent from 'public/assets/security-policy.md'
import { getCommonServerSideProps } from 'services'

export default function Security() {
    const { isAuthenticated } = useContext(UserContext)
    const { t, i18n } = useTranslation('security')

    return (
        <>
            <Navbar isAuth={isAuthenticated} />
            <Seo
                path="/security"
                title={t('seoTitle')}
                description={t('seoDescription')}
                lang={i18n.language}
            />
            <Container width="xs" style={{ margin: 'var(--space-48) auto var(--space-64)' }}>
                <HtmlRenderer html={htmlContent} />
            </Container>
            <Footer hairlineBackgroundColor="var(--ui-border)" />
        </>
    )
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    const { locale, ...commonProps } = await getCommonServerSideProps(ctx)

    return {
        props: {
            ...commonProps,
            ...(await serverSideTranslations(locale, ['security', 'common'])),
        },
    }
}
